import sendRequest from "../../../helpers/requestHelper";
import config from "../../../config";
import {handleError} from "../../../helpers/handleError";
import eventBus from "../../../event-bus/eventBus";

const updateClientPerson = {
    namespaced: true,
    state: {
        textInfoPersonUpdate: "",
        typeInfoPersonUpdate: "",
        headInfoPersonUpdate: "",
        isPersonUpdate: false,
        dataUpdatePersonIsFetching: true
    },
    mutations: {
        DATA_UPDATE_SUCCESS(state, response) {
            state.textInfoPersonUpdate = response.data.data.textInfo;
            state.headInfoPersonUpdate = response.data.message;
            state.isPersonUpdate = true;
            state.typeInfoPersonUpdate = "green";
        },
        DATA_UPDATE_FAILURE(state, error) {
            state.textInfoPersonUpdate = handleError(error) !== "" ? handleError(error) : error.response.data.data.message;
            state.typeInfoPersonUpdate = "red";
            state.headInfoPersonUpdate = error.response.data.message;
            state.isPersonUpdate = true;
            state.dataUpdatePersonIsFetching = false;
            eventBus.$emit("saveClientFailure", error.response.data.errors);
        },
        UPDATE_VISIBLE_MODAL_UPDATE(state, value) {
            state.isPersonUpdate = value;
        }
    },
    actions: {
        updateClientPerson: function({ dispatch }, payload) {
            var promise = sendRequest("put", config.baseURLApi + "/client-persons/" + payload.creds.client_id, {}, payload.creds);

            promise.then(function(result) {
                if(result[0] === "success") {
                    dispatch("successDataUpdate", result[1])
                } else {
                    dispatch("failureDataUpdate", result[1]);
                }
            });
        },
        successDataUpdate: function({ commit }, response) {
            commit("DATA_UPDATE_SUCCESS", response);
        },
        failureDataUpdate: function({ commit } , error) {
            commit("DATA_UPDATE_FAILURE", error);
        },
        updateVisibleModalUpdatePerson: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL_UPDATE", value);
        }
    }
};

export default updateClientPerson;